import React from 'react';
import LegalDocument from '@/components/LegalDocument';

export default function Terms() {
  return <LegalDocument document="terms" />;
}
